import type { SanityPageBuilderDistributorsSection, SanityPageBuilderSection, SanityReferenceSummary } from "@ouster/shared";
import { DistributorsBlockView } from "~/features/blocks/inventory/distributors";
import type { DistributorCardFragment } from "~/gql/graphql";

// `initialDistributors` is loaded server-side by the distributors section loader
// (reference-section-loaders.server.ts) and embedded in sectionContent.
type DistributorsSectionContent = SanityPageBuilderDistributorsSection & {
  initialDistributors?: DistributorCardFragment[];
};
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderDistributorsSection;
  };
};
type DistributorsViewIndustry = {
  id?: string | null;
};
export function SanityDistributorsSection({
  section
}: Props) {
  const {
    sectionSettings
  } = section;
  const content = section.sectionContent as DistributorsSectionContent;
  const industries = content.industries?.map<DistributorsViewIndustry>((industry: SanityReferenceSummary) => ({
    id: industry._id
  })) ?? [];
  return <DistributorsBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} industries={industries} initialDistributors={content.initialDistributors ?? []} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}